import React, { useState, useEffect } from 'react';

import {
    Container,
    Stack,
    Typography,
    Button,
    TextField,
    Card,
    TableRow,
    TableBody,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    IconButton,
    MenuItem,
    Popover,
    TablePagination,
    Pagination,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Autocomplete,
    Box
} from '@mui/material'
import Iconify from '../iconify/Iconify';
import api from '../../api';
import { toast } from 'react-toastify';

import CircularProgressWithLabel from '../../utils/loader';

const PAYMENT_TYPES = [
    { label: 'Without To Pay', value : 'Without To Pay' },
    { label: 'To Pay', value: 'To Pay' },
    { label: 'Both', value: 'Both' },
    { label: 'Cash', value: 'Cash' }
  
  ];
const ShowBillsComponent = () => {
    const [showBills, setBills] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchPageCount, setSearchPageCount] = useState({
        page: 1,
        total_pages: 0,
        total: 0,
        current_page: 1
    });
    const [showBillData, setShowBillData] = useState(null);
    const [searchQuery, setSearchQuery] = useState({
        dateFrom: "",
        dateTo: "",
        paymentType: "",
        clientId: "",
        clientName: ""
    });

    const [open, setOpen] = useState(null);
    const [clients, setClients] = useState([]);
    const handleOpenMenu = (event) => {
        setOpen(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setOpen(null);
    };

    useEffect(() => {
        fetchBills();
        fetchClients();
    }, []);

    const fetchBills = async () => {
        setLoading(true);
        const response = await api.get('/api/v1/billing', { params: { ...searchPageCount, filters: { ...searchQuery }   } });
        if (response.data.success) {
            setBills(response.data.billings);
            setSearchPageCount(response.data.pageInfo);
            setLoading(false);
        } else {
            toast.error(response.data.message);
            setLoading(false);
        }
    }

    const fetchClients = async () => {
        try {
          const response = await api.get('/api/v1/clients');
          if (response.data.success) {
            const clientsData = response.data.clients.map((item) => ({
              label: `${item.name} (${item.gstNo})`,
              value: item,
              id: item.id
            }));
            clientsData.push({ label: 'General', value: null, id: 'General' });
            setClients(clientsData);
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error('Something went wrong!');
        }
      };
    

    const viewMoreResult = (event, newPage) => {
        searchPageCount.page = newPage;
        setSearchPageCount({ ...searchPageCount });
        fetchBills();
    };

    const onClickOptiionData = (bills) => {
        setShowBillData(bills);
    }
    const onClickDownloadBill = () => {
        const pdfBase64 = showBillData.pdfData;
  
        if (pdfBase64) {
          // Convert Base64 to binary
          const byteCharacters = atob(pdfBase64);
          const byteNumbers = new Array(byteCharacters.length)
            .fill()
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
  
          // Create a Blob from the bytes
          const blob = new Blob([byteArray], { type: 'application/pdf' });
  
          // Create a download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
  
          // Set filename dynamically (optional)
          link.download = `Billing_${new Date().toISOString().slice(0, 10)}.pdf`;
          document.body.appendChild(link);
          link.click();
  
          // Cleanup
          link.remove();
          window.URL.revokeObjectURL(url);
        }
    }

    const onChangeSearch = (event) => {
        setSearchQuery({ ...searchQuery, [event.target.name]: event.target.value });
    }

    const onClientChange = (event, values) => {
        if (!values) return;
        setSearchQuery(prev => ({ ...prev, clientId: values.id, clientName: values.label }));
      };

    const onClickSearch = () => {
        fetchBills();
    }
    const onClickReset = () => {
        setSearchQuery({
            dateFrom: "",
            dateTo: "",
            paymentType: "",
            clientId: "",
            clientName: ""
        });
        setSearchPageCount({
            page: 1,
            total_pages: 0,
            total: 0,
            current_page: 1
        });
        fetchBills();
    }

  
    return (
        <>
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                    Previous Bills
                </Typography>
                </Stack>

                <Card style={{ marginBottom: "30px" }}>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ my: 2 }}>
                        <Autocomplete
                            disablePortal
                            id="client-autocomplete"
                            options={clients}
                            style={{ minWidth: 180, flex: 1 }}
                            onChange={onClientChange}
                            size="small"
                            value={clients.find(client => client.label === searchQuery.clientName) || clients[0]}
                            getOptionLabel={(option) => option.label || ''}
                            isOptionEqualToValue={(option, value) => option.label === value?.label}
                            renderInput={(params) => <TextField {...params} label="Client" size="small" />}
                        />
                        <TextField
                            label="Bill #"
                            name="billNumber"
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 110, flex: 1 }}
                            onChange={onChangeSearch}
                        />
                        <TextField
                            label="From"
                            name="createdDateFrom"
                            type="date"
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 125, flex: 1 }}
                            InputLabelProps={{ shrink: true }}
                            onChange={onChangeSearch}
                        />
                        <TextField
                            label="To"
                            name="createdDateTo"
                            type="date"
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 125, flex: 1 }}
                            InputLabelProps={{ shrink: true }}
                            onChange={onChangeSearch}
                        />
                        <TextField
                            select
                            label="Status"
                            name="paymentStatus"
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 120, flex: 1 }}
                            value={searchQuery.paymentStatus || ""}
                            onChange={onChangeSearch}
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="true">Paid</MenuItem>
                            <MenuItem value="false">Not Paid</MenuItem>
                        </TextField>
                        <TextField
                            select
                            label="Type"
                            name="paymentType"
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 120, flex: 1 }}
                            value={searchQuery.paymentType || ""}
                            onChange={onChangeSearch}
                        >
                            <MenuItem value="">All</MenuItem>
                            {PAYMENT_TYPES.map((type) => (
                                <MenuItem key={type.value || type.label} value={type.label}>
                                    {type.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Box sx={{ display: "flex", flex: 1, minWidth: 130, justifyContent: "flex-end", gap: 1 }}>
                            <Button variant="contained" onClick={onClickSearch} size="small">
                                Search
                            </Button>
                            <Button variant="outlined" onClick={onClickReset} size="small">
                                Reset
                            </Button>
                        </Box>
                    </Stack>
                </Card>
                <Card>
                    {loading ? <CircularProgressWithLabel  /> :
                        <>
                            <TableContainer >
                                <Table sx={{ minWidth: 150 }} size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" >
                                                SNo
                                            </TableCell>
                                            <TableCell align="center" >
                                               Bill Number
                                            </TableCell>
                                            <TableCell align="center" >
                                               Client Name
                                            </TableCell>
                                            <TableCell align="center">
                                                Created On
                                            </TableCell>
                                            <TableCell align="center">
                                            Amount
                                            </TableCell>
                                            <TableCell align="center">
                                            GST Amount
                                            </TableCell>
                                            <TableCell align="center">
                                            Discount Amount
                                            </TableCell>
                                            <TableCell align="center">
                                            Total Amount
                                            </TableCell>
                                            <TableCell align="center">
                                           Total Weight
                                            </TableCell>
                                            <TableCell align="center">
                                            Total Packages
                                            </TableCell>
                                            <TableCell align="center">
                                            Payment Type
                                            </TableCell>
                                            <TableCell align="center">
                                            Paid Status
                                            </TableCell>
                                            <TableCell align="center">
                                            
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {showBills.length > 0 && showBills.map((bills, index) => (
                                            <TableRow hover>
                                               <TableCell align="center">
                                               {(parseInt(searchPageCount.current_page || 1) - 1) * 10 + index + 1}
                                                </TableCell>
                                                <TableCell align="center" onClick={(e)=>onClickPackage(e,bills)}> <b>{bills.billNumber}</b></TableCell>

                                                <TableCell align="center">
                                                   
                                                        {bills.clientName}
                                                    
                                                </TableCell>
                                                <TableCell align="center">
                                                    {bills.createdAt ? new Date(bills.createdAt).toLocaleDateString() : "NA"}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {bills.amount}
                                                </TableCell>
                                                <TableCell align="center">
                                                {bills.gstAmount}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {bills.discountAmount}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {bills.finalAmount}
                                                </TableCell>
                                    
                                                <TableCell align="center">
                                                {bills.totalWeight}
                                                </TableCell>
                                                <TableCell align="center">
                                                {bills.totalPackages}
                                                </TableCell>
                                                <TableCell align="center">
                                                   {bills.paymentType}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {bills.paid ? "Paid" : "Unpaid"}
                                                </TableCell>
                                                
                                               
                                                <TableCell align="right" onClick={() => onClickOptiionData(bills)}>
                                                    <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                                                        <Iconify icon={'eva:more-vertical-fill'} />
                                                    </IconButton>

                                                </TableCell>
                                            </TableRow>
                                        ))
                                        }
                                        {showBills.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={12} align="center" style={{ height: "200px", verticalAlign: "middle" }}>
                                                    <Typography variant="h6" color="text.secondary">
                                                        No data found
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {showBills.length > 0 && (
                            <Stack alignItems="center" py={2}>
                                <Pagination
                                    color='primary'
                                    onChange={viewMoreResult}
                                    page={searchPageCount.current_page}
                                    count={searchPageCount.total_pages}
                                />
                            </Stack>
                            )}
                            <Popover
                                open={Boolean(open)}
                                anchorEl={open}
                                onClose={handleCloseMenu}
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{
                                    sx: {
                                        p: 1,
                                        width: 140,
                                        '& .MuiMenuItem-root': {
                                            px: 1,
                                            typography: 'body2',
                                            borderRadius: 0.75,
                                        },
                                    },
                                }}
                            >
                                <MenuItem onClick={() => onClickDownloadBill()}>
                                    <Iconify icon={'eva:download-fill'} sx={{ mr: 2 }} />
                                    Download
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}>
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </Popover>
                        </>
                    }
                </Card>
       
            </Container>
        </>
    );
};

export default ShowBillsComponent;